export default __webpack_public_path__ + "static/media/raccoon_5.ed84d925.png";